"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLaboratory = exports.getIsEspSyncMisconfigured = exports.getEspSyncMisconfigurationDetails = exports.getEspSyncLastError = exports.getEspSyncType = exports.getEspSync = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _reselect = require("reselect");

var _EmailProviders = require("settings-ui-modules/marketing/modules/esp-sync/constants/EmailProviders");

var _constants = require("settings-ui-sdk/EspSync/constants");

var getEspSync = function getEspSync(state) {
  return state.modules.marketing['email-service-provider'].entities.espSync;
};

exports.getEspSync = getEspSync;
var getEspSyncType = (0, _reselect.createSelector)([getEspSync], function (espSync) {
  return espSync.get(_constants.ESP_TYPE);
});
exports.getEspSyncType = getEspSyncType;
var getEspSyncLastError = (0, _reselect.createSelector)([getEspSync], function (espSync) {
  return espSync.get(_constants.ESP_LAST_ERROR);
});
exports.getEspSyncLastError = getEspSyncLastError;
var getEspSyncMisconfiguredReason = (0, _reselect.createSelector)([getEspSync], function (espSync) {
  return espSync.get(_constants.ESP_MISCONFIGURED_REASON);
});
var getEspSyncMisconfigurationDetails = (0, _reselect.createSelector)([getEspSyncType, getEspSyncMisconfiguredReason], function (type, reason) {
  var key = 'marketing.espSync.status.misconfigured.other';

  if (_EmailProviders.APIKEY_EMAIL_PROVIDERS.indexOf(type) !== -1) {
    if (reason === _constants.EspMisconfiguredReason.INVALID_CREDENTIALS) {
      key = 'marketing.espSync.status.misconfigured.apiKeyInvalidCredentials';
    } else if (reason === _constants.EspMisconfiguredReason.NO_CREDENTIALS) {
      key = 'marketing.espSync.status.misconfigured.apiKeyNoCredentials';
    }
  } else if (_EmailProviders.OAUTH_EMAIL_PROVIDERS.indexOf(type) !== -1) {
    if (reason === _constants.EspMisconfiguredReason.INVALID_CREDENTIALS) {
      key = 'marketing.espSync.status.misconfigured.oauthInvalidCredentials';
    } else if (reason === _constants.EspMisconfiguredReason.NO_CREDENTIALS) {
      key = 'marketing.espSync.status.misconfigured.oauthNoCredentials';
    }
  }

  return _I18n.default.text(key);
});
exports.getEspSyncMisconfigurationDetails = getEspSyncMisconfigurationDetails;
var getIsEspSyncMisconfigured = (0, _reselect.createSelector)([getEspSync], function (espSync) {
  return espSync.get(_constants.ESP_CONNECTION_STATUS) === _constants.EspConnectionStatus.BROKEN;
});
exports.getIsEspSyncMisconfigured = getIsEspSyncMisconfigured;

var getLaboratory = function getLaboratory(state) {
  return state.modules.marketing['email-service-provider'].entities.laboratory;
};

exports.getLaboratory = getLaboratory;